import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-extracurricullaractivities',
    templateUrl: './extracurricullaractivities.component.html',
    styleUrls: ['./extracurricullaractivities.component.scss']
})
export class ExtracurricullaractivitiesComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Extracurricular Activities: Empowering Student Growth');
        this.meta.updateTag({
            name: 'description',
            content: `Explore the diverse Extracurricular Activities offered, fostering creativity, teamwork, and leadership skills, while enhancing personal growth and campus life.`
        });
    }

}
